/**
 * Immutable `code` values of the LUT rows the UI has to single out by hand.
 *
 * Mirrors the backend `NrgMetrics.Constants.LutCodes`. Match LUT rows on these instead of on
 * `name`: names are user-editable and some carry long-standing typos (the Individual sub-category
 * is stored as "Indivindual"), so a name match silently finds nothing.
 */
export const LutCodes = {
  /** Codes for large shareholder categories (`/api/lut/large-shareholder-categories`). */
  shareholderCategory: {
    widelyHeldFirm: 'WIDELY_HELD_FIRM',
    externalBlockholders: 'EXTERNAL_BLOCKHOLDERS',
    /** Sub-category of External Blockholders. */
    individual: 'INDIVIDUAL'
  }
} as const;
